import axios from '../utils/axios'

export async function validateDomain (domain, userId) {
  let { data } = await axios({
    url: '/v1/validate/domain',
    method: 'post',
    data: { domain: domain, user_id: userId }
  })
  return data
}

export async function validateEmail (email) {
  let { data } = await axios({
    url: '/v1/validate/email',
    method: 'post',
    data: { email: email }
  })
  return data
}

export async function validateSupportCode (email, supportCode) {
  let { data } = await axios({
    url: '/v1/validate/support_code',
    method: 'post',
    data: { email: email, support_code: supportCode }
  })
  return data
}

export async function validateUserdata (userdata) {
  let { data } = await axios({
    url: '/v1/validate/userdata',
    method: 'post',
    data: userdata
  })
  return data
}
